import axiosInstance from "../../api/axios";

const baseUrl = '/exercices';

const ExerciceService = {
  listAllExercices: async () => {
    try {
      const response = await axiosInstance.get(baseUrl);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch exercises');
      }
    } catch (error) {
      throw error;
    }
  },

  showExerciceDetails: async (id) => {
    try {
      const response = await axiosInstance.get(`${baseUrl}/${id}`);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch exercise details');
      }
    } catch (error) {
      throw error;
    }
  },

  createNewExercices: async (exercicesData) => {
    try {
      const response = await axiosInstance.post(baseUrl, { exercices: exercicesData });
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to create exercises');
      }
    } catch (error) {
      throw error;
    }
  },

  updateExerciceDetails: async (id, data) => {
    try {
      const response = await axiosInstance.put(`${baseUrl}/${id}`, data);
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to update exercise details');
      }
    } catch (error) {
      throw error;
    }
  },

  deleteExercice: async (id) => {
    try {
      const response = await axiosInstance.delete(`${baseUrl}/${id}`);
      return response.data; // Return the entire response data
    } catch (error) {
      throw error;
    }
  },
  deleteExerciceMedia: async (id) => {
    try {
      const response = await axiosInstance.delete(`${baseUrl}/${id}/media`);
      if (response.status === 204) {
        return { success: true };
      } else {
        throw new Error('Failed to delete exercise media');
      }
    } catch (error) {
      throw error;
    }
  },
};

export default ExerciceService;